<template>
  <div class="sidebar__row" v-if="canContactTeam">
    <ContactTeamItem :item="rm" modal-key="contactRM" v-if="rm"></ContactTeamItem>
    <ContactTeamItem :item="am" modal-key="contactAM" v-if="am"></ContactTeamItem>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ContactTeamItem from './nav-menu-items/ContactTeamItem.vue';

  export default {
    name: 'ContactTeamMenu',
    components: {
      ContactTeamItem,
    },
    computed: {
      ...mapGetters('main', ['permissions', 'am', 'rm', 'canContactTeam']),
    },
  };
</script>
